export type Flags = { [flagName: string]: string | undefined };

export const TRUE_FLAG = "true";
export const FALSE_FLAG = "false";

export const FLASHPCB_FLAG_PREFIX = "FlashPCB.flag.";

export const DRC_EXPLANATION_FLAG = `${FLASHPCB_FLAG_PREFIX}drcExplanation`;
export const SEEN_SALES_ENGINEER_BANNER = `${FLASHPCB_FLAG_PREFIX}seenSalesEngineerBanner`;
export const LAST_CAD_SOURCE_UPLOADED = `${FLASHPCB_FLAG_PREFIX}lastCADSourceUploaded`;
export const ALL_FLAGS = [DRC_EXPLANATION_FLAG, SEEN_SALES_ENGINEER_BANNER];
